import http from '@/requests/http'
import appConfig from '@/config/app'

class AgentInboundDetailsStatistics {
  static findAll (params) {
    return http.post('agents/inbound-details/statistics/index', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/agents/inbound-details/statistics/export?${URLparams}`, '_blank')
  }
}

export default AgentInboundDetailsStatistics
